import { render, staticRenderFns } from "./CopyStakeDashboardStatisticTile.vue?vue&type=template&id=fee9aa5e&scoped=true&lang=pug"
import script from "./CopyStakeDashboardStatisticTile.vue?vue&type=script&lang=ts"
export * from "./CopyStakeDashboardStatisticTile.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeDashboardStatisticTile.vue?vue&type=style&index=0&id=fee9aa5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee9aa5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VSkeletonLoader})
